import { guestClient } from '@/api/guestClient'
import { apiClient } from '@/api'

const BASE = '/submittals'

export const getSubmittalMeta = async (submittalId, consultantId) => {
  const res = await guestClient.get(`${BASE}/${submittalId}/meta`, {
    params: { consultantId },
  })
  return res.data
}

export const getSubmittalDetails = async submittalId => {
  const res = await apiClient.get(`${BASE}/${submittalId}/details`)
  return res.data
}

export const getSubmittalSchema = async dataElementId => {
  const res = await apiClient.get(`/data-elements/${dataElementId}`)
  return res.data
}

export const getAllDataElements = async () => {
  const res = await apiClient.get('/data-elements')
  return res.data
}

export const approveSubmittal = async submittalId => {
  const res = await apiClient.post(`${BASE}/${submittalId}/approve`)
  return res.data
}

export const rejectSubmittal = async (submittalId, reason) => {
  const res = await apiClient.post(`${BASE}/${submittalId}/reject`, { reason })
  return res.data
}

export const getActivityLogs = async submittalId => {
  const res = await apiClient.get(`${BASE}/${submittalId}/activity-logs`)
  return res.data
}

export const getSubmittalListing = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams()

    const appendParam = (key, value) => {
      if (value === undefined || value === null) return
      if (Array.isArray(value)) {
        value.forEach(v => queryParams.append(key, v))
      } else {
        queryParams.append(key, value)
      }
    }

    appendParam('page', params.page)
    appendParam('page_size', params.page_size)
    appendParam('search', params.search)
    appendParam('sort', params.sort)
    appendParam('order', params.order)
    appendParam('data_element_id', params.data_element_id)
    appendParam('project_contract_name', params.project_contract_name)
    appendParam('submission_month', params.submission_month)
    appendParam('status', params.status)

    const qs = queryParams.toString()
    const res = await apiClient.get(`consultant${BASE}${qs ? `?${qs}` : ''}`)

    const response = res.data

    const items = response?.data || []
    const mappedData = items.map(item => ({
      id: item.submittal_id,
      data_element_id: item.data_element_id,
      submission_month: item.submission_month,
      modified: item.modified,
      project_contract_name: item.payload?.project_details?.project_contract_name || '',
      request_id: item.request_id,
      status: item.status,
    }))

    return {
      data: mappedData,
      pagination: {
        currentPage: response.pagination.page,
        totalPages: response.pagination.total_pages,
        totalItems: response.pagination.total,
        hasNext: response.pagination.page < response.pagination.total_pages,
        hasPrev: response.pagination.page > 1,
      },
      success: true,
    }
  } catch (error) {
    console.error('Error fetching submittal listing:', error)
    throw new Error(error.response?.data?.detail || 'Failed to fetch submittals')
  }
}

export const downloadSubmittalCsv = async (submittalId, format = 'csv') => {
  try {
    const res = await apiClient.get(`submittals/download/${submittalId}/${format}`, {
      responseType: 'text',
    })
    return { data: res.data, error: null }
  } catch (error) {
    return { data: null, error: error.response?.data?.detail || 'Failed to download file' }
  }
}

export const getSubmittalFilters = async () => {
  try {
    const response = await apiClient.get(`${BASE}/filters`)
    return {
      dataElementIds: response.data.data_element_ids || [],
      project_contract_names: (response.data.project_contracts || []).map(
        c => c.project_contract_name
      ),
      submission_months: response.data.submission_months || [],
      statuses: response.data.statuses || [],
      success: true,
    }
  } catch (error) {
    console.error('Error fetching submittal filters:', error)
    throw new Error(error.response?.data?.detail || 'Failed to fetch filters')
  }
}
